module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-landing-scholars-310ddcb14b555f4b2418b949b694b28e.svg";